import * as React from 'react'

export const Error: React.FC = () => {
  return <div className="mt-2 text-red-500 text-sm">This field is required</div>
}
